import request from './request'
import * as http from '@/libs/http'

/**
 * 店舗の免責補償一覧を取得する
 *
 * @param {Number} shopid 店舗ID
 * @returns {Response} レスポンスデータ
 */
export function getShopInsurances (shopid) {
  return request.get(`/shops/${shopid}/insurances`, {
    params: {
      fields: [
        'id',
        'categories',
        'name',
        'default',
        'unitCharge',
        'limited',
        'maxDays'
      ]
    },
    validateStatus: (status) => [
      http.OK,
      http.NoContent
    ].includes(status)
  })
}
